module.exports = __webpack_public_path__ + "static/media/escrever-pt.8ec8cb3a.svg";